/*
  Modo catálogo — Klassey.

  A loja virou vitrine: quem compra, compra no Mercado Livre. Este arquivo faz duas
  coisas e nada além disso:

  1. Dispara o evento CliqueMeli (Meta, TikTok e GA4) quando alguém clica em
     qualquer link do Mercado Livre. É um clique, não uma compra, e o nome do evento
     diz isso — quem otimiza campanha escolhe este evento como meta.
  2. Trava o que sobrou de carrinho: bloqueia envio de formulário de adicionar ao
     carrinho e tira da frente as páginas /cart e /checkout, caso alguém chegue nelas
     por link antigo ou histórico do navegador.
*/
(function () {
  'use strict';

  // avisa o resto do tema (ex.: vistos recentemente) que a loja está em modo catálogo
  window.KLASSEY_CATALOGO = true;

  function enviarEvento(dados) {
    try { if (window.fbq) fbq('trackCustom', 'CliqueMeli', dados); fbq('trackCustom', 'Vitrine', dados); } catch (e) {}
    try { if (window.ttq) ttq.track('ClickButton', { content_name: 'CliqueMeli', value: dados.value, currency: dados.currency }); } catch (e) {}
    try {
      if (window.gtag) gtag('event', 'clique_meli', dados);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: 'clique_meli' }, dados));
    } catch (e) {}
  }

  document.addEventListener('click', function (evento) {
    var link = evento.target.closest('a[data-klassey-meli], a[href*="mercadolivre.com"], a[href*="mercadolibre.com"]');
    if (!link) return;
    enviarEvento({
      value: parseFloat(link.dataset.meliPreco || 0) || 0,
      currency: 'BRL',
      content_name: link.dataset.meliProduto || document.title,
      destino: link.dataset.meliDestino || 'loja',
      pagina: location.pathname,
    });
  }, true);

  // nada de carrinho: se sobrou formulário em alguma página, ele não envia
  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
      evento.preventDefault();
      evento.stopPropagation();
    }
  }, true);

  if (/^\/(cart|checkout)/.test(location.pathname)) {
    location.replace('/');
  }

  // nenhum caminho de compra sobrevive: some com botão de compra dinâmico e link de checkout
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"], a[href*="/checkout"], a[href*="/cart/"]').forEach(function (e) {
      e.remove();
    });
  });

  // filtro por preço não faz sentido numa vitrine sem preço
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('details').forEach(function (d) {
      var titulo = d.querySelector('summary');
      if (titulo && /^\s*pre[çc]o\s*$/i.test(titulo.textContent || '')) d.style.display = 'none';
    });
  });

  // As páginas de /policies/ são desenhadas pela própria Shopify e o texto da política de
  // privacidade é gerenciado automaticamente (a API recusa alterá-lo). Então o contato sai aqui,
  // no texto já renderizado, para não sobrar e-mail nem telefone em lugar nenhum.
  var MAIL = /[\w.+-]+@[\w-]+\.[\w.]{2,}/g;
  var FONE = /\+?\s*55?\s*\(?\d{2}\)?[\s\u00a0-]*9?[\s\u00a0-]*\d{4}[-\s\u00a0]?\d{4}/g;
  var DESTINO = 'nosso canal no Mercado Livre';

  function limpaContato(raiz) {
    var passeio = document.createTreeWalker(raiz || document.body, NodeFilter.SHOW_TEXT, null);
    var no;
    while ((no = passeio.nextNode())) {
      var pai = no.parentNode;
      if (!pai || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(pai.nodeName)) continue;
      var texto = no.nodeValue;
      if (!texto || (texto.indexOf('@') < 0 && !/\d{4}/.test(texto))) continue;
      var limpo = texto.replace(MAIL, DESTINO).replace(FONE, DESTINO);
      if (limpo !== texto) no.nodeValue = limpo;
    }
    document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"], a[href*="wa.me"], a[href*="api.whatsapp"]').forEach(function (a) {
      a.replaceWith(document.createTextNode(DESTINO));
    });
  }

  document.addEventListener('DOMContentLoaded', function () { limpaContato(document.body); });
})();
